// extracted by mini-css-extract-plugin
export default {"deviceLogItemContainer":"site-device-log-item_deviceLogItemContainer__i0UAT"};